<template lang="pug">
.activity__bg
  .activity(id='activity')
    .activity__title.mobile АКТИВНОСТИ
    img.activity__img.mobile(src='../static/activityMobM.png')
    img.activity__img.pc(src='../static/activityMob.png')
    .activity__content
      .activity__title.pc АКТИВНОСТИ
      .activity__subtitle Участвуйте в активностях <br> и меняйте реальность
      .activity__list
        .activity__item
          .activity__img-block
            img.activity__item-img(src='../static/activity1.svg')
          .activity__item-content
            .activity__item-title Аплодисменты
            .activity__item-subtitle Используйте кнопку «Аплодисменты» на платформе рядом с окном видео-плеера
        
        .activity__item
          .activity__img-block
            img.activity__item-img(src='../static/activity2.svg')
          .activity__item-content
            .activity__item-title Instagram
            .activity__item-subtitle Во время регистрации вы предоставили данные своей странички в Instagram и теперь у вас есть шанс увидеть себя на нашей digital-трибуне. Если вы пропустили этот шаг, можете сделать это прямо сейчас
        
        .activity__item
          .activity__img-block
            img.activity__item-img(src='../static/activity3.svg')
          .activity__item-content
            .activity__item-title Видео
            .activity__item-subtitle Снимайте видео с вашим участием и высылайте нашему администратору в WhatsApp по телефону +7 (903) 107-73-77
</template>

<script>
export default {
  name: 'activity',
};
</script>

<style lang="sass">
.activity
  position: relative
  display: flex
  max-width: 970px
  margin: 0 auto
  padding: 148px 20px 43px
  box-sizing: border-box
  justify-content: space-between
  @media screen and (max-width: 812px)
    flex-direction: column
    padding: 60px 20px 40px
    max-width: 375px
  &__bg
    position: relative
    @media screen and (max-width: 812px)
      &::before
        content: ''
        z-index: 0
        background: linear-gradient(180deg, #6A489D 0%, #754985 50%, rgba(117, 73, 133, 0) 100%);
        top: 0
        right: 0
        left: 0
        height: 369px
        position: absolute
  &__img-block
    width: 56px
    margin-right: 40px
    min-width: 56px
    @media screen and (max-width: 812px)
      margin-right: 20px
  &__img
    @media screen and (max-width: 812px)
      position: relative
      margin-bottom: 40px
  &__content
    display: flex
    flex-direction: column
    position: relative
  &__title
    font-size: 14px
    line-height: 16px
    letter-spacing: 2px
    color: #FFFFFF
    mix-blend-mode: normal
    opacity: 0.3
    margin-bottom: 43px
    font-weight: bold
    @media screen and (max-width: 812px)
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      margin-bottom: 40px
  &__subtitle
    font-size: 36px;
    line-height: 42px;
    color: #FFFFFF;
    margin-bottom: 50px
    @media screen and (max-width: 812px)
      margin-bottom: 67px
  &__list
    display: flex
    flex-direction: column
  &__item
    display: flex
    max-width: 471px
    &:not(:last-child)
      margin-bottom: 27px
      @media screen and (max-width: 812px)
        margin-bottom: 40px
    &-img
    &-content
      display: flex
      flex-direction: column
    &-title
      font-size: 14px
      line-height: 16px
      color: #FFFFFF
      margin-bottom: 13px
      @media screen and (max-width: 812px)
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 10px
    &-subtitle
      font-size: 14px;
      line-height: 17px;
      color: #FFFFFF;
      mix-blend-mode: normal;
      opacity: 0.5;
      @media screen and (max-width: 812px)
        font-size: 15px;
        line-height: 21px;
</style>
